import { ReactNode } from "react";

const InputBox = ({ children }: { children: ReactNode }) => {
  return (
    <div className="rounded-box glass-blurry w-full p-3 md:p-5 z-1 shadow-lg">
      {children}
    </div>
  );
};
export default InputBox;
